import { CommonModule, Location } from '@angular/common';
import { EventEmitter, Component, Input, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AddressFormatterPipe } from 'src/app/address-formatter.pipe';
import { APIServiceService } from 'src/app/api/apiservice.service';
import { CustomerEditFormComponent } from 'src/app/components/customer-edit-form/customer-edit-form.component';
import { Address } from 'src/app/models/address.model';
import { AppointmentType } from 'src/app/models/appointment-type.model';
import { Appointment } from 'src/app/models/appointment.model';
import { Fitter } from 'src/app/models/fitter.model';
import { Horse } from 'src/app/models/horse.model';
import { SaddleType } from 'src/app/models/saddle-type.model';
import { EntityTypesService } from 'src/app/services/entity-types.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { SharedUIModuleModule } from 'src/app/shared/shared-uimodule/shared-uimodule.module';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core';
import moment from 'moment';
import { NoCustomerMessageComponent } from 'src/app/components/no-customer-message/no-customer-message.component';
import { CustomerSearchComponent } from 'src/app/components/customer-search/customer-search.component';
import { Customer } from 'src/app/models/customer.model';
import { HorseSelectCreateComponent } from 'src/app/components/horse-select-create/horse-select-create.component';
import { AddressSelectCreateComponent } from 'src/app/components/address-select-create/address-select-create.component';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/services/modal.service';
import Swal from 'sweetalert2';
import { AppointmentRatingComponent } from 'src/app/components/appointment-rating/appointment-rating.component';
import { ModelSearchComponent } from 'src/app/components/model-search/model-search.component';
import { Rider } from 'src/app/models/rider.model';

import {  faEdit } from '@fortawesome/free-solid-svg-icons';
import { AppointmentEditorService } from 'src/app/services/appointment-editor.service';
import { AppointmentSummaryComponent } from 'src/app/components/appointment-summary/appointment-summary.component';

@Component({
  selector: 'ubc-appointment-edit-slideover',
  standalone: true,
  providers:[
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ],
  imports: [
    CommonModule, 
    ReactiveFormsModule, 
    FormsModule, 
    SharedUIModuleModule,
    CustomerEditFormComponent,
    NgxMaterialTimepickerModule,
    MatFormFieldModule, 
    MatInputModule, 
    MatDatepickerModule,
    NoCustomerMessageComponent,
    CustomerSearchComponent,
    HorseSelectCreateComponent,
    AddressSelectCreateComponent,
    AppointmentRatingComponent,
    ModelSearchComponent
    
    
    
    
    
  ],
  
  templateUrl: './appointment-edit-slideover.component.html',
  styleUrl: './appointment-edit-slideover.component.scss'
})
export class AppointmentEditSlideoverComponent {

  faEdit = faEdit

  @Input() appointment?: Appointment
  @Input() open: boolean = false
  @Output() wasClosed = new EventEmitter()

  editMode = false

  private eventSubscription: Subscription

  public time: Date;

  appointmentTypes: AppointmentType[];
  saddleTypes: SaddleType[];
  fitters: Fitter[];
  tables = [];

  customerForm: FormGroup
  appointmentForm: FormGroup

  pickedStartTime: string = '11:10 am'
  pickedEndTime: string = '11:30 am'

  constructor(
    private apiService: APIServiceService,
    private entityTypesService: EntityTypesService,
    private notificationsService: NotificationsService,
    private location: Location,
    private modalService: ModalService,
    private appointmentEditorService: AppointmentEditorService
  ){

    // this.customerForm = new FormGroup({
    //   id: new FormControl(0, Validators.required),
    //   firstName: new FormControl('', Validators.required),
    //   lastName: new FormControl('', Validators.required),
    //   email: new FormControl('', Validators.required),
    //   tel: new FormControl('', Validators.required)
    // })

    this.appointmentForm = new FormGroup({
      startTime: new FormControl('', Validators.required),
      endTime: new FormControl('', Validators.required),
      addressId: new FormControl('', Validators.required),
      typeId: new FormControl('', Validators.required),
      fitterId: new FormControl('', Validators.required),
      customerId: new FormControl('', Validators.required),
      riderId: new FormControl(''),
      notes: new FormControl('', Validators.maxLength(500)),
      horseId: new FormControl('', Validators.required),
      saddleTypeId: new FormControl(''),
      budget: new FormControl(0),
      status: new FormControl('PENDING', Validators.required),
      riderWeightKg: new FormControl(0),
      riderHeightCm: new FormControl(0)
    })

  }

  ngOnInit(){
   

      this.eventSubscription = this.modalService.event$.subscribe(event => {
        if (event.type === 'CUSTOMER') {
         console.log("Customer event recieved ", event)
  
         if(event.action === "horses_updated" ){
            if(event.newHorse){
              this.appointment.horse = event.newHorse
            }
         }

         if( event.action === "addresses_updated"){
          if(event.newAddress){
            this.appointment.address = event.newAddress
          }
       }
        }
      });


   
    
  }
 

  closeClicked(){
    console.log("Close clicked")
    this.open = false
    
    setTimeout(() => {
      this.appointment = undefined
      this.appointmentForm.reset()
      this.wasClosed.emit()
    }, 200)
    
  }

  // Additional method to handle touch events on mobile
  closeTouched(event: TouchEvent) {
    console.log("Close touched")
    event.preventDefault()
    event.stopPropagation()
    this.closeClicked()
  }

  editClicked(){
    console.log("edit clicked")
    this.appointmentEditorService.addUrlParam("edit", "1")
    this.initAppointment()
  }



  async initAppointment() {
    console.log("init appointment called")
    const currentPath = this.location.path().split('?')[0];
  
    // Get the current query parameters
    const searchParams = new URLSearchParams(this.location.path().split('?')[1]);
    const appointmentIdFromUrl = searchParams.get("appt")
    const editParam = searchParams.get("edit")
    if(!appointmentIdFromUrl){
      return
    }
   const appointmentId =(appointmentIdFromUrl === "new") ? undefined : parseInt(appointmentIdFromUrl, 10)

   

   if(editParam || appointmentIdFromUrl === 'new'){
    this.editMode = true
   } else {
    this.editMode = false
   }
    
   
    if(appointmentId){

    try {
    const appointmentResponse = await this.apiService.appointments.getByID(appointmentId, ['customer_addresses', 'customer_horses', 'customer_riders'])
      if(!appointmentResponse.success){
        throw new Error("Error retrieving appointment")
      }

      this.appointment = new Appointment().deserialize(appointmentResponse.data)
      this.appointment.customer.addresses.sort((a, b) => b.isMostRecentlyUsed - a.isMostRecentlyUsed)

      console.log("Got appointment details ", this.appointment)
     

      

    } catch(e){
      throw e
    }
  } 

    const allEntities = await this.entityTypesService.getAllEntities()

    this.appointmentTypes = allEntities.appointmentTypes;
    this.saddleTypes = allEntities.saddleTypes;
    this.fitters = allEntities.fitters;

    this.pickedStartTime = this.getTimeStringFromDate(this.appointment.startTime.toDate())
    this.pickedEndTime = this.getTimeStringFromDate(this.appointment.endTime.toDate())

    this.populateFormsWithAppointment()

   

    this.open = true

  

    
  }

  populateFormsWithAppointment(){
    if(!this.appointment)
      return
    // this.populateCustomerForm()
    this.populateAppointmentForm()
  }

  // populateCustomerForm(){
  //   this.customerForm.patchValue(this.appointment.customer)

  //   console.log(this.customerForm.value)
  // }

  // async customerFormSubmit(){

  //   try {
  //   const updated = await this.apiService.customer.update(this.customerForm.value)
  //   this.notificationsService.add("success", "Customer Details Updated", `${this.customerForm.value.firstName} ${this.customerForm.value.lastName} details were sucessfully updated`)
  //   } catch(e){
  //     throw e
  //   }
  // }

  // Address cofiguration

  // addressClicked(address: Address) {
  //   if( this.appointment.address.id === address.id){
  //     return
  //   }

  //   this.appointment.address = address

  //   this.populateAppointmentForm()

    

  // }

  statusChanged(){
    this.appointment.status = this.appointmentForm.value.status
    console.log(this.appointment.status)
  }

  populateAppointmentForm(){
    let startTime = (this.appointment.startTime) ? this.appointment.startTime.toDate() : undefined
    let endTime = startTime


    startTime = this.setTime(startTime, this.pickedStartTime)
    endTime = this.setTime(endTime, this.pickedEndTime)


    const appointmentFormDetails = {
      addressId: (this.appointment.address ) ? this.appointment.address.id : 0,
      typeId: (this.appointment.type) ? this.appointment.type.id : undefined,
      fitterId: (this.appointment.fitter) ? this.appointment.fitter.id : undefined,
      notes: ( this.appointmentForm.get('notes').dirty ) ? this.appointmentForm.get('notes').value : this.appointment.notes || "",
      horseId: (this.appointment.horse) ? this.appointment.horse.id : 0,
      saddleTypeId: (this.appointment.saddleType) ? this.appointment.saddleType.id : undefined,
      budget: (this.appointmentForm.get('budget').dirty) ? +this.appointmentForm.get('budget').value : 0,
      startTime: startTime,
      endTime: endTime,
      status: (this.appointment.status ) ? this.appointment.status : 'PENDING',
      riderWeightKg: (this.appointment.riderWeightKg) ? this.appointment.riderWeightKg : 0,
      riderHeightCm: (this.appointment.riderHeightCm) ? this.appointment.riderHeightCm : 0,
      customerId: (this.appointment.customer) ? this.appointment.customer.id : undefined
    }

    this.appointmentForm.patchValue(appointmentFormDetails)
  }

  async appointmentFormSubmit(){
    
    try {
      this.appointment.budget = this.appointmentForm.value.budget
      this.appointment.notes = this.appointmentForm.value.notes
      this.populateAppointmentForm()
      const appointmentDetails = this.appointmentForm.value
      appointmentDetails.startTime = moment(appointmentDetails.startTime).format('YYYY-MM-DD HH:mm:ss')
      appointmentDetails.endTime = moment(appointmentDetails.endTime).format('YYYY-MM-DD HH:mm:ss')
      appointmentDetails.riderId = this.appointment.riderId
      // appointmentDetails.customerId = this.appointment.customer.id

     
      
      if(this.appointment.id){
        await this.apiService.appointments.patch(this.appointment.id, appointmentDetails)
      } else {
        console.log("Create apppointment with details ", appointmentDetails)
        
        await this.apiService.appointments.create(appointmentDetails)
      }


      
      this.notificationsService.add("success", `${this.appointment.customer.firstName} ${this.appointment.customer.lastName} Appointment details updated`)
      this.closeClicked()
      this.modalService.broadcastEvent({ type: 'APPOINTMENTS', action: 'refresh_required' })
    } catch(e){
      this.notificationsService.add("error", `Error updating appointment details`)
      throw e
    }
  }

  // appoinmtent type configuration
  appoinmentTypeClicked(type: AppointmentType) {
    this.appointment.type = type
    this.pickedEndTime = this.addDurationToTimeString(this.pickedStartTime, this.appointment.type.duration)
    this.populateAppointmentForm()
  }


  // fitter configuration
  fitterClicked(fitter: Fitter){
    this.appointment.fitter = fitter
    this.populateAppointmentForm()
  }

  horseSelected(horse : Horse | undefined){
    this.populateAppointmentForm()
  }

  addressSelected(address?: Address){
    this.populateAppointmentForm()
  }

  // horseClicked(horse: Horse) {
  //   console.log("horseClicked")
  //   if( this.appointment.horse.id === horse.id){
  //     this.appointment.horse = null
  //   } else {
  //     this.appointment.horse = horse
  //   }

    

  //   this.populateAppointmentForm()

    

  // }

  saddleTypeClicked(saddleType: SaddleType, event: MouseEvent){
    
    if(this.appointment.saddleType && this.appointment.saddleType.id === saddleType.id){
      this.appointment.saddleType = null
    } else {
      this.appointment.saddleType = saddleType
    }

    this.populateAppointmentForm()
  }
  
  onDateChange(event: any): void {
    console.log('Date changed:', event.value, typeof event);
    this.appointment.startTime = moment(event.value)
    this.populateAppointmentForm()
    
  }

  onTimeChange(newTime: string, time: 'start' | 'end'){
    
    this.populateAppointmentForm()
  }

  setTime(date: Date, timeString: string): Date {
    const [time, modifier] = timeString.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
  
    if (modifier === 'PM' && hours !== 12) {
      hours += 12;
    } else if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }
  
    const updatedDate = new Date(date);
    updatedDate.setHours(hours);
    updatedDate.setMinutes(minutes);
    updatedDate.setSeconds(0);
    updatedDate.setMilliseconds(0);
    
    return updatedDate;
  }

  addDurationToTimeString(timeString: string, duration: number): string {
    const [time, modifier] = timeString.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
  
    if (modifier === 'PM' && hours !== 12) {
      hours += 12;
    } else if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }
  
    // Calculate the total minutes
    const totalMinutes = hours * 60 + minutes + duration * 60;
  
    // Calculate new hours and minutes
    const newHours = Math.floor(totalMinutes / 60) % 24;
    const newMinutes = Math.floor(totalMinutes % 60);
  
    // Determine the new modifier
    const newModifier = newHours >= 12 ? 'PM' : 'AM';
    const adjustedHours = newHours > 12 ? newHours - 12 : newHours === 0 ? 12 : newHours;
  
    // Format new time string
    const newTimeString = `${adjustedHours}:${newMinutes.toString().padStart(2, '0')} ${newModifier}`;
  
    return newTimeString;
  }

  getTimeStringFromDate(date: Date): string {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const modifier = hours >= 12 ? 'PM' : 'AM';
  
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesStr = minutes.toString().padStart(2, '0');
  
    const timeString = `${hours}:${minutesStr} ${modifier}`;
    return timeString;
  }

  isSelectedObject(targetkey: string, id: number): boolean{
    if(!this.appointment[targetkey]){
      return false
    }

    return this.appointment[targetkey].id === id

  }

  customerSelectionCleared(){
    this.appointment.customer = undefined
  }

  customerPickedFromSearch(customer: Customer){
    if(!customer){
      return
    }
    this.appointment.customer = customer

   
  }

  riderPickedFromSearch(rider: Rider){
    if(!rider){
      return
    }

    console.log("Search picked rider ", rider)

    this.appointment.riderId = rider.id
    this.appointment.riderWeightKg = rider.weightKg
    this.appointment.riderHeightCm = rider.heightCm

    this.appointment.rider = rider
  }



  deselectRider() {
    this.appointment.riderId = 0
    this.appointment.riderHeightCm = 0
    this.appointment.riderWeightKg = 0
    this.appointment.rider = null
  }

  async deleteClicked(){
    const confirmed = await Swal.fire({
      title: "Delete appointment?",
      text: "Are you sure you would like to delete this appointment?",
      showCancelButton: true
    })

    if(confirmed.isConfirmed){
      await this.apiService.appointments.delete(this.appointment.id)
      this.notificationsService.add("success", `${this.appointment.customer.firstName} ${this.appointment.customer.lastName} Appointment deleted`)
      this.closeClicked()
      this.modalService.broadcastEvent({ type: 'APPOINTMENTS', action: 'refresh_required' })
    }
  }

  async confirmAppointmentClicked(){
    if(!this.appointment){
      return
    }

   const confirmedResponse = await this.apiService.appointments.confirm(this.appointment.id)
   if(confirmedResponse.success){
    this.appointment.status = "CONFIRMED"
   }
  }
}
